//
// Product Customization — v2 template
// Handles iframe communication with editor.marketdwellings.com
// for the redesigned product page (main-product-v2.liquid).
//
$(document).ready(function () {

  //
  // Edit-design resume — detect `?edit_customization=<id>&line=<key>` in URL.
  // These params are set by the cart's "Edit design" link and tell us to:
  //   1) Open the editor iframe with a resume config (type='edit-basic',
  //      project=<id>) — NOT the fresh-customize config that uses template.
  //   2) On submit, update the existing cart line's `Customization ID` and
  //      `_Mockup Url` props via /cart/change.js, then return to /cart —
  //      instead of adding a new cart line.
  //
  // Wire protocol confirmed by Richard 2026-04-23:
  //   Init  → { type: 'edit-basic', project: '<dh_project_id>' }
  //   Reply → same `single-customization` message as normal flow, with a new
  //           `customization` id and new `mockupUrl`.
  //
  var resumeProjectId = (function () {
    try {
      var params = new URLSearchParams(window.location.search);
      var id = params.get('edit_customization');
      return id && id.length ? id : null;
    } catch (e) {
      return null;
    }
  })();

  var resumeLineKey = (function () {
    try {
      var params = new URLSearchParams(window.location.search);
      var k = params.get('line');
      return k && k.length ? k : null;
    } catch (e) {
      return null;
    }
  })();

  // ─── Editor wire logging ────────────────────────────────────────
  // Every postMessage sent to the editor iframe and every message
  // received back is logged to the browser console so we (or Richard)
  // can audit the wire protocol for accuracy. Silence with
  //   localStorage.setItem('md-editor-debug','0')
  // and reload. Re-enable with '1' (or any value other than '0').
  var MDLOG = {
    on: (function () { try { return localStorage.getItem('md-editor-debug') !== '0'; } catch (e) { return true; } })(),
    _clone: function (v) { try { return typeof v === 'object' && v !== null ? JSON.parse(JSON.stringify(v)) : v; } catch (e) { return v; } },
    out: function (label, payload) {
      if (!this.on) return;
      try {
        console.groupCollapsed('%c[MD → Editor]%c ' + label,
          'background:#1e3329;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
          'color:#1e3329;font-weight:600');
        console.log(this._clone(payload));
        console.groupEnd();
      } catch (e) {}
    },
    in: function (label, payload) {
      if (!this.on) return;
      try {
        console.groupCollapsed('%c[Editor → MD]%c ' + label,
          'background:#1f8a78;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
          'color:#1f8a78;font-weight:600');
        console.log(this._clone(payload));
        console.groupEnd();
      } catch (e) {}
    },
    note: function (label, data) {
      if (!this.on) return;
      try {
        if (data === undefined) {
          console.log('%c[MD]%c ' + label,
            'background:#666;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
            'color:#333');
        } else {
          console.groupCollapsed('%c[MD]%c ' + label,
            'background:#666;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
            'color:#333');
          console.log(this._clone(data));
          console.groupEnd();
        }
      } catch (e) {}
    },
    skip: function (origin, data) {
      if (!this.on) return;
      try {
        console.groupCollapsed('%c[Editor ✗]%c message from ' + origin + ' — ignored (origin mismatch)',
          'background:#c24a3b;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
          'color:#c24a3b');
        console.log(this._clone(data));
        console.groupEnd();
      } catch (e) {}
    }
  };
  MDLOG.note('product-customization-v2 loaded', {
    resumeProjectId: resumeProjectId,
    resumeLineKey: resumeLineKey,
    href: window.location.href
  });

  // When resuming, build the minimal "edit-basic" config Richard's editor
  // expects. Do NOT send template/rollup/color — the editor loads those from
  // the existing project on DH's side.
  function buildResumeConfig() {
    return withCustomerContext({
      type: 'edit-basic',
      project: resumeProjectId,
    });
  }

  // After the editor returns a new customization id + mockup url, update the
  // existing cart line's properties and return to /cart. We merge onto the
  // line's current properties so we don't accidentally strip anything extra.
  function updateCartLineOnResume(lineKey, dhData) {
    MDLOG.note('updateCartLineOnResume: start', { lineKey: lineKey, dhData: dhData });
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = (cart.items || []).find(function (it) { return it.key === lineKey; });
        var currentProps = (line && line.properties) || {};
        MDLOG.note('updateCartLineOnResume: current line props (before merge)', currentProps);
        var merged = Object.assign({}, currentProps, {
          'Customization ID': dhData.customization || currentProps['Customization ID'] || '',
          '_Mockup': dhData.mockupName || currentProps['_Mockup'] || '',
          '_Mockup Url': dhData.mockupUrl || currentProps['_Mockup Url'] || '',
        });
        if (dhData.dhCookie) merged['_DHcookie'] = dhData.dhCookie;
        MDLOG.note('updateCartLineOnResume: merged props (POSTing to /cart/change.js)', merged);

        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: lineKey, properties: merged }),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        MDLOG.note('updateCartLineOnResume: /cart/change.js OK, redirecting to /cart', data);
        window.location.assign('/cart');
      })
      .catch(function (err) {
        console.error('[md-customize] resume cart update FAILED', err);
        MDLOG.note('updateCartLineOnResume: FAILED — falling back to /cart anyway', String(err));
        // fall back to cart anyway — customer sees old line but no blank crash
        window.location.assign('/cart');
      });
  }

  //
  // Resolve the current variant directly from the active UI state.
  // This avoids relying on hidden #product__sku / #variant__id divs
  // that may not be in sync when the user clicks Customize.
  //
  function getCurrentVariant() {
    var D = window.mdProductData;
    if (!D) return null;

    // Build a selected-options map from the active buttons + qty dropdown
    var selected = {};
    // Style buttons (e.g. Material, Holes)
    document.querySelectorAll('.md-style-btn.active').forEach(function (btn) {
      selected[btn.dataset.option] = btn.dataset.value;
    });
    // Swatch buttons (e.g. Color)
    document.querySelectorAll('.md-swatch-btn.active').forEach(function (btn) {
      selected[btn.dataset.option] = btn.dataset.value;
    });
    // Quantity dropdown
    var qtySelect = document.getElementById('md-qty-select');
    if (qtySelect) {
      // Find which option name is the "quantity" option
      var qtyKeywords = ['quantity', 'qty', 'units', 'sets', 'pack', 'packs'];
      D.options.forEach(function (name) {
        var lower = name.toLowerCase();
        qtyKeywords.forEach(function (kw) {
          if (lower.indexOf(kw) !== -1) {
            selected[name] = qtySelect.value;
          }
        });
      });
    }

    // Find matching variant
    var match = null;
    D.variants.forEach(function (v) {
      if (match) return;
      var isMatch = true;
      D.options.forEach(function (name, i) {
        if (v['option' + (i + 1)] !== selected[name]) {
          isMatch = false;
        }
      });
      if (isMatch) match = v;
    });

    return match;
  }

  //
  // Listen for messages from the customization editor iframe
  //
  window.addEventListener(
    'message',
    (event) => {
      // Ensure message is from the editor iframe
      if (event.origin === 'https://editor.marketdwellings.com') {
        var _label = (typeof event.data === 'string')
          ? event.data
          : (event.data && event.data.type) ? event.data.type : 'message';
        MDLOG.in(_label, event.data);

        if (event?.data === 'cancel') {
          // Handle cancel — restore product page
          var customizationSection = $('#product_customization');
          var productWrap = $('#md-product-wrap');
          var siblingShopifySections = productWrap.closest('.shopify-section').nextAll('.shopify-section');

          customizationSection.fadeOut();
          productWrap.fadeIn();
          siblingShopifySections.fadeIn();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          customizationSection.empty();
        } else if (event?.data === 'contact-us') {
          // Open HelpScout Beacon
          Beacon('open');
        } else if (event?.data === 'frame-initialized') {
          // Frame ready — send customization config to complete initialization
          var variant = getCurrentVariant();
          var currentVariantId = variant ? String(variant.id) : $('#variant__id').text();
          var currentSku = variant ? (variant.sku || '') : $('#product__sku').text();

          var variantCustomizationConfig = $(`.variant__customization_config[variantId="${currentVariantId}"]`).text();
          var productCustomizationConfig = $('#product__customization_config').text();

          if (resumeProjectId) {
            // Resume an existing Design Huddle project — ignore the product's
            // fresh-customize configs entirely; editor loads state from DH.
            const resumeConfig = buildResumeConfig();
            MDLOG.out('resume config (type=edit-basic)', resumeConfig);
            document.getElementById('product-customization-frame').contentWindow.postMessage(resumeConfig, '*');
          } else if (variantCustomizationConfig) {
            const customizationConfig = withCustomerContext(JSON.parse(variantCustomizationConfig));
            MDLOG.out('variant-level customization config', customizationConfig);
            document.getElementById('product-customization-frame').contentWindow.postMessage(customizationConfig, '*');
          } else if (productCustomizationConfig) {
            const customizationConfig = withCustomerContext(JSON.parse(productCustomizationConfig));
            MDLOG.out('product-level customization config', customizationConfig);
            document.getElementById('product-customization-frame').contentWindow.postMessage(customizationConfig, '*');
          } else {
            // No explicit config — build from SKU + rollup + color
            var variantColor = getActiveSwatchColor();
            const editorConfig = buildEditorConfig(currentSku, $('#customization_rollup_template').text(), variantColor);
            MDLOG.out('editor config built from SKU + rollup + color', editorConfig);
            document.getElementById('product-customization-frame').contentWindow.postMessage(editorConfig, '*');
          }
        } else if (event?.data?.type === 'single-customization') {
          if (resumeLineKey) {
            // Resume flow — update the existing cart line's properties and
            // bounce back to /cart instead of adding a new line.
            MDLOG.note('single-customization → resume flow (updateCartLineOnResume)', { resumeLineKey: resumeLineKey });
            updateCartLineOnResume(resumeLineKey, event.data);
          } else {
            // Normal flow — single item customization complete, add to cart
            MDLOG.note('single-customization → normal flow (appending hidden inputs, submitting md-cart-form)', {
              'properties[Customization ID]': event?.data?.customization,
              'properties[_Mockup]': event?.data?.mockupName,
              'properties[_Mockup Url]': event?.data?.mockupUrl,
              'properties[_DHcookie]': event?.data?.dhCookie || '(omitted)'
            });
            var mdProductForm = $('.md-cart-form');
            mdProductForm.append(`<input type="hidden" name="properties[Customization ID]" value="${event?.data?.customization}" />`);
            mdProductForm.append(`<input type="hidden" name="properties[_Mockup]" value="${event?.data?.mockupName}" />`);
            mdProductForm.append(`<input type="hidden" name="properties[_Mockup Url]" value="${event?.data?.mockupUrl}" />`);
            if (event?.data?.dhCookie) {
              mdProductForm.append(`<input type="hidden" name="properties[_DHcookie]" value="${event?.data?.dhCookie}" />`);
            }
            mdProductForm.submit();
          }
        } else if (event?.data?.type === 'bundle-customization') {
          // Bundle customization complete — add to cart
          MDLOG.note('bundle-customization → appending hidden inputs, submitting md-cart-form', {
            'properties[Bundle ID]': event?.data?.bundle,
            'properties[_Mockup]': event?.data?.mockupName,
            'properties[_Mockup Url]': event?.data?.mockupUrl,
            'properties[_DHcookie]': event?.data?.dhCookie || '(omitted)'
          });
          var mdProductForm = $('.md-cart-form');
          mdProductForm.append(`<input type="hidden" name="properties[Bundle ID]" value="${event?.data?.bundle}" />`);
          mdProductForm.append(`<input type="hidden" name="properties[_Mockup]" value="${event?.data?.mockupName}" />`);
          mdProductForm.append(`<input type="hidden" name="properties[_Mockup Url]" value="${event?.data?.mockupUrl}" />`);
          if (event?.data?.dhCookie) {
            mdProductForm.append(`<input type="hidden" name="properties[_DHcookie]" value="${event?.data?.dhCookie}" />`);
          }
          mdProductForm.submit();
        } else {
          MDLOG.note('message from editor did not match any known type — ignored', event.data);
        }
      } else {
        // Non-editor origin — log and ignore. Browser noise (extensions, iframe
        // libraries, React Devtools) all show up here; filter as needed.
        MDLOG.skip(event.origin, event.data);
      }
    },
    false
  );

  //
  // Get active swatch color from v2 swatch buttons
  //
  const getActiveSwatchColor = () => {
    var activeSwatch = document.querySelector('.md-swatch-btn.active');
    if (activeSwatch) {
      return activeSwatch.getAttribute('data-value');
    }
    return null;
  };

  //
  // Add customer context to customization configuration object
  //
  const withCustomerContext = (customizationConfiguration) => {
    var customerEmail = $('#customer__email').text();
    if (customerEmail) {
      customizationConfiguration.email = customerEmail;
    }

    var customerName = $('#customer__name').text();
    if (customerName) {
      customizationConfiguration.customerName = customerName;
    }

    var customerPhone = $('#customer__phone').text();
    if (customerPhone) {
      if (customerPhone.length == 12 && customerPhone.charAt(0) == '+') {
        customerPhone = `${customerPhone.substring(2, 5)}.${customerPhone.substring(5, 8)}.${customerPhone.substring(8)}`;
      }
      customizationConfiguration.customerPhone = customerPhone;
    }
    return customizationConfiguration;
  };

  //
  // Build editor configuration for item
  //
  const buildEditorConfig = (sku, rollupTemplate, paperColor) => {
    let editorConfig = {
      type: 'basic',
      template: sku,
      rollup: rollupTemplate,
      color: paperColor,
    };
    return withCustomerContext(editorConfig);
  };

  //
  // Handle customize button click (v2 button: #md-customize-btn)
  //
  $(document).on('click', '#md-customize-btn', function () {
    // Resolve the current variant fresh from the UI state
    var variant = getCurrentVariant();
    var currentVariantId = variant ? String(variant.id) : $('#variant__id').text();
    var currentSku = variant ? (variant.sku || '') : $('#product__sku').text();
    var currentQuantity = $('#md-qty-select').val();

    // Also sync the hidden divs so they stay current
    if (variant) {
      $('#variant__id').text(variant.id);
      $('#product__sku').text(variant.sku || '');
    }

    MDLOG.note('customize button clicked', {
      variantId: currentVariantId,
      sku: currentSku,
      quantity: currentQuantity,
      isMobile: isMobileOrTabletBrowser(),
      resumeProjectId: resumeProjectId,
      resumeLineKey: resumeLineKey
    });

    if (isMobileOrTabletBrowser()) {
      // Mobile/tablet — redirect to editor
      var variantCustomizationConfig = $(`.variant__customization_config[variantId="${currentVariantId}"]`).text();
      var productCustomizationConfig = $('#product__customization_config').text();

      if (resumeProjectId) {
        // Resume — send minimal edit-basic config. NOTE: mobile return flow
        // hits callbackUri=marketdwellings.com and the cart line update won't
        // happen via the single-customization handler (which only fires in
        // the iframe postMessage path). Mobile resume is currently a
        // known-limited path — the edit submits and lands on the homepage.
        // TODO(phase2): detect return-from-editor state and call
        // updateCartLineOnResume from a post-return handler.
        const resumeConfig = buildResumeConfig();
        // Tack on &line=<key> so a future return handler can find the line.
        var mUrl = `https://editor.marketdwellings.com/editor?mobile=true&callbackUri=${encodeURI('https://marketdwellings.com/cart')}&variantId=${currentVariantId}&quantity=${currentQuantity}&line=${encodeURIComponent(resumeLineKey || '')}&config=${encodeURIComponent(JSON.stringify(resumeConfig))}`;
        MDLOG.out('mobile redirect (resume)', { url: mUrl, config: resumeConfig });
        window.location.assign(mUrl);
      } else if (variantCustomizationConfig) {
        const customizationConfig = withCustomerContext(JSON.parse(variantCustomizationConfig));
        var mUrl2 = `https://editor.marketdwellings.com/editor?mobile=true&callbackUri=${encodeURI('https://marketdwellings.com')}&variantId=${currentVariantId}&quantity=${currentQuantity}&config=${encodeURIComponent(JSON.stringify(customizationConfig))}`;
        MDLOG.out('mobile redirect (variant config)', { url: mUrl2, config: customizationConfig });
        window.location.assign(mUrl2);
      } else if (productCustomizationConfig) {
        const customizationConfig = withCustomerContext(JSON.parse(productCustomizationConfig));
        var mUrl3 = `https://editor.marketdwellings.com/editor?mobile=true&callbackUri=${encodeURI('https://marketdwellings.com')}&variantId=${currentVariantId}&quantity=${currentQuantity}&config=${encodeURIComponent(JSON.stringify(customizationConfig))}`;
        MDLOG.out('mobile redirect (product config)', { url: mUrl3, config: customizationConfig });
        window.location.assign(mUrl3);
      } else {
        var variantColor = getActiveSwatchColor();
        const editorConfig = buildEditorConfig(currentSku, $('#customization_rollup_template').text(), variantColor);
        var mUrl4 = `https://editor.marketdwellings.com/editor?mobile=true&callbackUri=${encodeURI('https://marketdwellings.com')}&variantId=${currentVariantId}&quantity=${currentQuantity}&config=${encodeURIComponent(JSON.stringify(editorConfig))}`;
        MDLOG.out('mobile redirect (built config)', { url: mUrl4, config: editorConfig });
        window.location.assign(mUrl4);
      }
    } else {
      // Desktop — open editor in iframe
      var customizationSection = $('#product_customization');
      customizationSection.empty();
      var iframeUrl = `https://editor.marketdwellings.com/editor`;
      MDLOG.note('desktop — opening editor iframe', { iframeUrl: iframeUrl });
      customizationSection.append(`<iframe id="product-customization-frame" src="${iframeUrl}" title="Product Customization" style="border:none;height:85vh;width:100%;" allow="clipboard-read; clipboard-write"></iframe>`);

      var productWrap = $('#md-product-wrap');
      var siblingShopifySections = productWrap.closest('.shopify-section').nextAll('.shopify-section');

      productWrap.fadeOut();
      siblingShopifySections.fadeOut();
      customizationSection.fadeIn();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  //
  // Check if browser is mobile or tablet
  //
  function isMobileOrTabletBrowser() {
    var check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  document.addEventListener("submit", function (e) {
    const form = e.target;

    if (!form.classList.contains("md-cart-form")) return;

    const active = document.activeElement;

    // if (
    //   active &&
    //   active.matches('input[name="quantity"]')
    // ) {
    //   e.preventDefault();
    //   e.stopImmediatePropagation();
    // }
  }, true);

  //
  // Auto-open the customize iframe when resuming an edit from the cart.
  // The edit_customization param was captured at the top of this file; if it's
  // set, click the customize button once the DOM is settled so the editor opens
  // with the project_id already in the config payload.
  //
  if (resumeProjectId) {
    setTimeout(function () {
      var btn = document.getElementById('md-customize-btn');
      if (btn) {
        btn.click();
      } else {
        console.warn('[md-customize] resume requested but #md-customize-btn not found');
      }
    }, 150);
  }

});
